export const DEVELOPERS_EXTERNAL_URLS = {
    API_DOCUMENTATION: "https://api.ai360access.com/docs",
};